document.addEventListener("DOMContentLoaded", function() {    

  console.log(`woocommerce.js loaded!`);

  /* Husky product filter (archive pages content) toggle
  ======================================== */

  jQuery('#product-filter').hide();
  jQuery('#product-filter-toggle').click(function(e) {
    jQuery(this).toggleClass('active');
    jQuery('#product-filter').slideToggle(300);
  });

  /* Category menu (archive pages content) toggle
  ======================================== */

  jQuery('#product-categories-dropdown').hide();
  jQuery('#product-categories-toggle').click(function (e) {
    jQuery(this).toggleClass("active");
    jQuery("#product-categories-dropdown").slideToggle(300);
  });

  /* Shop Categories Sidebar Nav
  ======================================== */
  // Uses SmartMenus Lib

  const catMenSel = ".sm.sm-vertical.wc-block-product-categories-list"; // selector for menu

  if (jQuery(catMenSel).length) {
    let wooCatMenu = jQuery(catMenSel).smartmenus({
      markCurrentItem: true,
      markCurrentTree: true,
      subIndicators: true,
      showOnClick: true,
      noMouseOver: true,
      collapsibleBehavior: 'link',
      hideOnClick: false
    });
      
    /**
     * Open current menus on page load
     */  
    document.querySelectorAll(`${catMenSel} a.has-submenu.current`).forEach((el) => {
      wooCatMenu.smartmenus('itemActivate', jQuery(el));
    })
  }

 	/* Select to Dropdown using Choices
  ======================================== */

  const orderbySelect = document.querySelector('select.orderby');  
  if (orderbySelect) {
    new Choices(orderbySelect, {
      searchEnabled: false,
      itemSelectText: '',
      shouldSort: false
    });
  }
 	
  /* Shop Slider
  ======================================== */

  const shopSliderContainer = document.querySelector("#shop-slider");
  if (shopSliderContainer) {
    const swiperElement = shopSliderContainer.querySelector(".swiper");
    const slides = shopSliderContainer.querySelectorAll(".swiper-slide");
    
    if (swiperElement && slides.length > 1) {
      const swiper = new Swiper(swiperElement, {
          slidesPerView: 1,
          loop: true,
          autoplay: {
              delay: 6000,
          },
          pagination: {
              el: "#shop-slider .swiper-pagination",
          },
          navigation: {
              nextEl: "#shop-slider .swiper-button-next",
              prevEl: "#shop-slider .swiper-button-prev",
          },            
      });
    }
  }

  
/* gallery
  ======================================== */

  // init gallery thumbs as slider with timeout
  function checkForGallery() {
    const galleryCheck = document.querySelector('.woocommerce-product-gallery .flex-control-thumbs');
    if (galleryCheck === null) {
      setTimeout(checkForGallery, 500);
    } else {
      if (galleryCheck.children.length > 4) {
        jQuery(galleryCheck).slick({        
          slidesToShow: 4,
          slidesToScroll: 4,
          arrows: false,
          dots: false,
          infinite: false,
        });
      }
    }
  }
  checkForGallery();

  /* Related Products Slider
  ======================================== */

  const relatedProducts = document.getElementById("similar-products-list");  
  const neuheitenProducts = document.getElementById("neuheiten-products-list");  

  if (relatedProducts) {    
    jQuery(relatedProducts).slick({
      prevArrow: '<button type="button" class="slick-prev custom-prev"><span class="u-visually-hidden">Previous</span></button>',
      nextArrow: '<button type="button" class="slick-next custom-next"><span class="u-visually-hidden">Next</span></button>',
      slidesToShow: 6,
      slidesToScroll: 6,
      arrows: true,
      dots: false,
      infinite: false,
      responsive: [        
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          }
        },
        {
          breakpoint: 390,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        }        
      ]
    });
  }

  if (neuheitenProducts) {    
    jQuery(neuheitenProducts).slick({
      prevArrow: '<button type="button" class="slick-prev custom-prev"><span class="u-visually-hidden">Previous</span></button>',
      nextArrow: '<button type="button" class="slick-next custom-next"><span class="u-visually-hidden">Next</span></button>',
      slidesToShow: 6,
      slidesToScroll: 6,
      arrows: true,
      dots: false,
      infinite: false,
      responsive: [        
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          }
        },
        {
          breakpoint: 390,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        }        
      ]
    });
  } 
}); 
  

